import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import ArTypeCode from './PropertiesControllerArTypeCode.jsx'
import Model from './ModelAr.mjs'

const PropertiesPaneBatchAr = (props) => (
    <PropertiesPane
        controllers={
            <>
                <ArTypeCode prop="arTypeCode" />
            </>
        }

        Model={Model}
        {...props}
    />
)

export default PropertiesPaneBatchAr
